import { Allowances } from '@sportOfferFederation/multi-market-select/types';

import RestService from './_private/RestService';

export default class AllowancesService {
    private restService = new RestService();

    public async getAllowances(): Promise<Allowances> {
        const data = await this.restService.getAllowances();
        // Since the multiplatform libs expects raw JSON to parse
        return JSON.stringify(data);
    }

    public async getAllowancesV2(): Promise<Allowances> {
        const data = await this.restService.getAllowancesV2();

        // Since the multiplatform libs expects raw JSON to parse
        return JSON.stringify(data);
    }
}
